<template>
  <v-container class="bg-white box-shadow rounded">
    <v-row>
      <v-col>
        <!-- name  -->
        <div class="filed mt-3">
          <span class="title">Name</span>
          <div class="input-container">
            <input type="text" v-model="ad_name" placeholder="Name Your ad" />
          </div>
          <div class="warning">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="#444546"
              xmlns="http://www.w3.org/2000/svg"
              class="warning-svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13 8C13 10.7614 10.7614 13 8 13V8V3C10.7614 3 13 5.23858 13 8ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
              ></path>
            </svg>
            <p class="small-text muted-text">Name is required.</p>
          </div>
        </div>
        <!-- profile  -->
        <div class="filed mt-3">
          <span class="title">Public Profile</span>
          <div class="profile-pic d-flex align-center ga-3">
            <div class="pic">
              <img
                :src="public_profile_id?.image"
                alt=""
              />
            </div>
            <div class="name d-flex flex-column ga-1">
              <div class=""> {{ public_profile_id?.name }} </div>
              <!-- <div class="small-text muted-text">Helmy</div> -->
            </div>
          </div>
        </div>
        <!-- brand name  -->
        <div class="filed mt-3">
          <span class="title">Brand Name * </span>
          <input
            type="text"
            v-model="brand_name"
            placeholder="Replace Profile Name"
          />
        </div>
        <!-- headline -->
        <div class="filed mt-3">
          <span class="title">Headline</span>
          <div class="input-container">
            <input type="text" v-model="headline" placeholder="Name Your ad" />
          </div>
          <div class="warning">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="#444546"
              xmlns="http://www.w3.org/2000/svg"
              class="warning-svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13 8C13 10.7614 10.7614 13 8 13V8V3C10.7614 3 13 5.23858 13 8ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
              ></path>
            </svg>
            <p class="small-text muted-text">headline is required.</p>
          </div>
        </div>
        <!-- offer details  -->
        <span
          v-if="offer_details_ad_disclaimer_ratio"
          class="radio-small"
          @click="offer_details_ad_disclaimer_ratio = false"
          >Remove Offer Details / Ad Disclaimer</span
        >
        <span
          v-else
          class="radio-small"
          @click="offer_details_ad_disclaimer_ratio = true"
          >Add Offer Details / Ad Disclaimer</span
        >
        <div v-if="offer_details_ad_disclaimer_ratio" class="filed mt-3">
          <span class="title">Offer Details / Ad Disclaimer </span>
          <div class="input-container">
            <input
              type="text"
              v-model="offer_details_ad_disclaimer"
              placeholder="Offer details / Ad Disclaimer"
            />
          </div>
          <div class="warning">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="#444546"
              xmlns="http://www.w3.org/2000/svg"
              class="warning-svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13 8C13 10.7614 10.7614 13 8 13V8V3C10.7614 3 13 5.23858 13 8ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
              ></path>
            </svg>
            <p class="small-text muted-text">
              Offer Details / Ad Disclaimer is required.
            </p>
          </div>
        </div>
        <!-- shareable  -->
        <div class="filed mt-3">
          <span class="title">Shareable</span>
          <div class="mt-3">
            <SwitchToogle
              @click="ToggleShareable"
              v-model:checked="shareable"
              :notAttached="false"
              :paused="false"
              :disabled="false"
            />
          </div>
        </div>
        <!-- shareable  -->
        <div class="filed mt-3">
          <span class="title">Play Style</span>
          <div class="mt-3">
            <span class="text-h6 muted-text">Auto Replay</span>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>

  <h6 class="page-header-title text-h6 mt-5">Story Snaps</h6>
  <v-container class="bg-white box-shadow rounded">
    <v-row>
      <v-col cols="7">
        <div class="filed mt-3">
          <div class="d-flex ga-3">
            <span
              v-for="(story, index) in storiesSnaps"
              :key="index"
              @click="OpenStorySnap(index)"
              :class="
                story.active
                  ? 'story-snaps-template position-relative active'
                  : 'story-snaps-template position-relative'
              "
              :style="{
                backgroundImage:
                  story.image_url && story.image_url !== ''
                    ? `url(${story.image_url})`
                    : 'url($(@/assets/snapchatImage/placeholder.png))',
              }"
            >
              <span v-if="story.image_url === '' && story.video_url === ''">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="white"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 13.8643V6.77002C17 6.47363 16.9321 6.19312 16.8115 5.94287L17.5933 5.28687C17.8516 5.72095 18 6.22827 18 6.77002V13.8643C18 15.521 16.6567 16.8643 15 16.8643H3.7959L4.98779 15.8643H15C16.1045 15.8643 17 14.9688 17 13.8643Z"
                  />
                  <path
                    d="M1.00342 13.9856C1.00098 13.9456 1 13.905 1 13.8643V6.77002C1 5.71753 1.85303 4.86426 2.90576 4.86426H3.41895C4.79346 4.86426 6.01416 3.98462 6.44873 2.68042C6.48486 2.57227 6.53516 2.47192 6.59766 2.3811C6.73145 2.18677 6.91992 2.03687 7.1377 1.94971C7.27588 1.89429 7.42578 1.86426 7.58105 1.86426H10.4189C10.9326 1.86426 11.3887 2.19312 11.5513 2.68042C11.7598 3.30591 12.1489 3.83374 12.6494 4.21362L13.4443 3.54663C13.0098 3.28296 12.6689 2.87012 12.5 2.36426C12.2012 1.46851 11.3633 0.864258 10.4189 0.864258H7.58105C6.63672 0.864258 5.79883 1.46851 5.5 2.36426C5.20117 3.26001 4.36328 3.86426 3.41895 3.86426H2.90576C1.30078 3.86426 0 5.16528 0 6.77002V13.8643C0 14.1626 0.043457 14.4509 0.124512 14.7229L1.00342 13.9856Z"
                  />
                  <path
                    d="M5.06006 10.5818C5.02051 10.356 5 10.1235 5 9.88647C5 7.67725 6.79102 5.88647 9 5.88647C9.48096 5.88647 9.94189 5.97144 10.3691 6.12695L9.42773 6.91675C9.28809 6.89673 9.14551 6.88647 9 6.88647C7.375 6.88647 6.05127 8.17871 6.00146 9.79175L5.06006 10.5818Z"
                  />
                  <path
                    d="M7.63135 13.6462C8.05859 13.8018 8.51904 13.8865 9 13.8865C11.209 13.8865 13 12.0957 13 9.88647C13 9.64941 12.9795 9.41724 12.9399 9.19165L11.9985 9.98145C11.9482 11.5942 10.625 12.8865 9 12.8865C8.85498 12.8865 8.7124 12.8762 8.57275 12.8562L7.63135 13.6462Z"
                  />
                  <path
                    d="M0.573835 16.957C0.396334 16.7455 0.423926 16.4301 0.635464 16.2526L16.7224 2.75404C16.9339 2.57654 17.2493 2.60413 17.4268 2.81567C17.6043 3.02721 17.5767 3.34258 17.3652 3.52008L1.27825 17.0186C1.06671 17.1961 0.751336 17.1685 0.573835 16.957Z"
                  />
                </svg>
              </span>
              <video
                v-if="story.video_url && story.image_url == ''"
                style="border-radius: 10px"
                width="100%"
                height="100%"
              >
                <source :src="story.video_url" type="video/mp4" />
              </video>
              <span class="validate"></span>
              <span
                v-if="storiesSnaps.length > 1"
                @click.stop="RemoveStorySnap(index)"
                class="delete"
                >X</span
              >
            </span>
            <span
              v-if="this.storiesSnaps.length < 10"
              @click="addNewStorySnap"
              class="add-story-snaps-template"
            >
              <img width="13" src="@/assets/snapchatImage/add.svg" alt="" />
            </span>
          </div>
        </div>
        <div v-for="(story, index) in storiesSnaps" :key="index">
          <div v-if="activeStorySnapIndex === index">
            <div class="filed mt-3">
              <span class="title">Topsnap Media</span>
              <div class="mt-3">
                <UploadMedia
                  :aspectRatio="9 / 16"
                  :minAspectRatio="9 / 16"
                  :maxAspectRatio="9 / 16"
                  :cropWidth="1080"
                  :cropHeight="1920"
                  :minCropWidth="1080"
                  :minCropHeight="1920"
                  :size="5"
                  @uploaded:id="(croppedImage) => updateID(croppedImage, index)"
                  @uploaded:url="(url) => updateImageUrl(url, index)"
                  @uploaded:video="(url) => updateVideoUrl(url, index)"
                  @uploaded:delete="deleteFile(index)"
                  :old_id="story.media_id"
                  :type="'all'"
                />
              </div>
            </div>
            <!-- signle snap data  -->
            <div class="filed mt-3">
              <div class="title">Attachment</div>
              <div class="mt-1">
                <span class="text-subtitle-2 muted-text">Website</span>
              </div>
              <v-select
                variant="solo"
                class="v-select-style"
                v-model="story.selected_ad_type"
                :items="adTypes"
                item-title="name"
                item-value="value"
              ></v-select>
            </div>
            <div v-if="story.selected_ad_type === 'DEEP_LINK'" class="">
              <div class="filed mt-3">
                <div class="title">Call To Action</div>
                <div class="mt-2">
                  <v-select
                    variant="solo"
                    class="v-select-style"
                    v-model="story.call_to_action"
                    :items="deep_link_ctas"
                    item-title="title"
                    item-value="value"
                  ></v-select>
                </div>
              </div>
              <div class="filed mt-3">
                <div class="title">Ad Favoriting</div>
                <div class="mt-2">
                  <SwitchToogle
                    @click="ToggleAdFavoriting"
                    v-model:checked="story.ad_favoriting"
                    :notAttached="false"
                    :paused="false"
                    :disabled="false"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <div class="title">Switch to Standard Button Color</div>
                <div class="mt-2">
                  <SwitchToogle
                    @click="ToggleStandardButtonColor"
                    v-model:checked="story.standard_button_color"
                    :notAttached="false"
                    :paused="false"
                    :disabled="false"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">App Name</span>
                <div class="input-container">
                  <input
                    type="text"
                    v-model="story.app_name"
                    placeholder="Name Your Website URL"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">Deeplink Uri </span>
                <div class="input-container">
                  <input
                    type="text"
                    v-model="story.deep_link_uri"
                    placeholder="Deeplink Uri"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">iOS App ID</span>
                <div class="input-container">
                  <input
                    type="text"
                    v-model="story.ios_app_id"
                    placeholder="iOS App ID"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">Android App Url</span>
                <div class="input-container">
                  <input
                    type="text"
                    v-model="story.android_app_url"
                    placeholder="Android App URL"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">Fallback Type</span>
                <div class="input-container">
                  <div class="">
                    <button
                      class="app-install-button"
                      :style="getButtonStyle(index, 'app_install')"
                      @click="story.fallback_type = 'app_install'"
                    >
                      App Install
                    </button>
                    <button
                      class="web-site-button"
                      :style="getButtonStyle(index, 'web_site')"
                      @click="story.fallback_type = 'web_site'"
                    >
                      Web Site
                    </button>
                  </div>
                </div>
              </div>
              <div class="" v-if="story.fallback_type === 'app_install'">
                <div class="filed mt-3">
                  <span class="title">Use Custom iOS Product Page</span>
                  <div class="mt-3">
                    <SwitchToogle
                      @click="ToggleCustomIosProductPage"
                      v-model:checked="story.custom_ios_product_page"
                      :notAttached="false"
                      :paused="false"
                      :disabled="false"
                    />
                  </div>
                </div>
                <div v-if="story.custom_ios_product_page" class="filed mt-3">
                  <span class="title">Custom Product Page ID</span>
                  <div class="input-container">
                    <input
                      type="text"
                      v-model="story.custom_ios_product_page_id"
                      placeholder="Custom Product Page ID"
                    />
                  </div>
                </div>
              </div>
              <div class="" v-if="story.fallback_type === 'web_site'">
                <div class="filed mt-3">
                  <span class="title">Web Site URL </span>
                  <div class="input-container">
                    <input
                      type="text"
                      v-model="story.fallback_website_url"
                      placeholder="Web Site URL"
                    />
                  </div>
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">App Icon</span>
                <div class="mt-3">
                  <UploadMedia
                    :aspectRatio="1 / 1"
                    :minAspectRatio="1 / 1"
                    :maxAspectRatio="1 / 1"
                    :maxCropWidth="2000"
                    :maxCropHeight="2000"
                    :minCropWidth="200"
                    :minCropHeight="200"
                    :cropWidth="200"
                    :cropHeight="200"
                    @uploaded:id="
                      (img) => uploadStoryimageAppIconFile(index, img)
                    "
                    @uploaded:url="(url) => updateStoryAppIconImage(index, url)"
                    @uploaded:delete="deleteAppIcon(index)"
                    :old_id="story.image_app_icon_id"
                  />
                </div>
              </div>
            </div>
            <div v-if="story.selected_ad_type === 'APP_INSTALL'" class="">
              <div class="filed mt-3">
                <div class="title">Call To Action</div>
                <div class="mt-2">
                  <v-select
                    variant="solo"
                    class="v-select-style"
                    v-model="story.call_to_action"
                    :items="app_install_ctas"
                    item-title="title"
                    item-value="value"
                  ></v-select>
                </div>
              </div>
              <div class="filed mt-3">
                <div class="title">Ad Favoriting</div>
                <div class="mt-2">
                  <SwitchToogle
                    @click="ToggleAdFavoriting"
                    v-model:checked="story.ad_favoriting"
                    :notAttached="false"
                    :paused="false"
                    :disabled="false"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <div class="title">Switch to Standard Button Color</div>
                <div class="mt-2">
                  <SwitchToogle
                    @click="ToggleStandardButtonColor"
                    v-model:checked="story.standard_button_color"
                    :notAttached="false"
                    :paused="false"
                    :disabled="false"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">App Name</span>
                <div class="input-container">
                  <input
                    type="text"
                    v-model="story.app_name"
                    placeholder="Name Your Website URL"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">iOS App ID</span>
                <div class="input-container">
                  <input
                    type="text"
                    v-model="story.ios_app_id"
                    placeholder="iOS App ID"
                  />
                </div>
              </div>
              <div>
                <div class="filed mt-3">
                  <span class="title">Use Custom iOS Product Page</span>
                  <div class="mt-3">
                    <SwitchToogle
                      @click="ToggleCustomIosProductPage"
                      v-model:checked="story.custom_ios_product_page"
                      :notAttached="false"
                      :paused="false"
                      :disabled="false"
                    />
                  </div>
                </div>
                <div v-if="story.custom_ios_product_page" class="filed mt-3">
                  <span class="title">Custom Product Page ID</span>
                  <div class="input-container">
                    <input
                      type="text"
                      v-model="story.custom_ios_product_page_id"
                      placeholder="Custom Product Page ID"
                    />
                  </div>
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">Android App Url</span>
                <div class="input-container">
                  <input
                    type="text"
                    v-model="story.android_app_url"
                    placeholder="Android App URL"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">App Icon</span>
                <div class="mt-3">
                  <UploadMedia
                    :aspectRatio="1 / 1"
                    :minAspectRatio="1 / 1"
                    :maxAspectRatio="1 / 1"
                    :maxCropWidth="2000"
                    :maxCropHeight="2000"
                    :minCropWidth="200"
                    :minCropHeight="200"
                    :cropWidth="200"
                    :cropHeight="200"
                    @uploaded:id="
                      (img) => uploadStoryimageAppIconFile(index, img)
                    "
                    @uploaded:url="(url) => updateStoryAppIconImage(index, url)"
                    @uploaded:delete="deleteAppIcon(index)"
                    :old_id="story.image_app_icon_id"
                    :extension="'png'"
                  />
                </div>
              </div>
            </div>
            <div v-if="story.selected_ad_type === 'WEB_VIEW'" class="">
              <div class="filed mt-3">
                <div class="title">Call To Action</div>
                <div class="mt-2">
                  <v-select
                    variant="solo"
                    class="v-select-style"
                    v-model="story.call_to_action"
                    :items="web_view_call_to_action_items"
                    item-title="title"
                    item-value="value"
                  ></v-select>
                </div>
              </div>
              <div class="filed mt-3">
                <div class="title">Ad Favoriting</div>
                <div class="mt-2">
                  <SwitchToogle
                    @click="ToggleAdFavoriting"
                    v-model:checked="story.ad_favoriting"
                    :notAttached="false"
                    :paused="false"
                    :disabled="false"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <div class="title">Switch to Standard Button Color</div>
                <div class="mt-2">
                  <SwitchToogle
                    @click="ToggleStandardButtonColor"
                    v-model:checked="story.standard_button_color"
                    :notAttached="false"
                    :paused="false"
                    :disabled="false"
                  />
                </div>
              </div>
              <div class="filed mt-3">
                <span class="title">Website URL</span>
                <div class="input-container">
                  <input
                    type="text"
                    v-model="story.website_url"
                    placeholder="Name Your Website URL"
                  />
                </div>
                <div class="warning">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="#444546"
                    xmlns="http://www.w3.org/2000/svg"
                    class="warning-svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13 8C13 10.7614 10.7614 13 8 13V8V3C10.7614 3 13 5.23858 13 8ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
                    ></path>
                  </svg>
                  <p class="small-text muted-text">Website URL is required.</p>
                </div>
              </div>
              <div class="filed mt-3">
                <div class="title">Smart Prefetching</div>
                <div class="mt-2">
                  <SwitchToogle
                    @click="ToggleSmartPerefetching"
                    v-model:checked="story.smart_prefetching"
                    :notAttached="false"
                    :paused="false"
                    :disabled="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-divider vertical></v-divider>
      <!-- review container  -->
      <v-col cols="5">
        <div class="">
          <div class="filed mt-3">
            <div class="title">Placement Preview</div>
            <div class="mt-2">
              <v-select
                variant="solo"
                class="v-select-style"
                v-model="placement_review"
                :items="[
                  { title: 'between Content', value: 'between_content' },
                  { title: 'Discover Feed', value: 'discover_feed' },
                  { title: 'Spotlight', value: 'spotlight' },
                ]"
                item-title="title"
                item-value="value"
              ></v-select>
            </div>
          </div>
          <div class="mt-3 d-flex justify-center">
            <!-- spotlight  -->
            <div
              @mouseenter="playVideo"
              @mouseleave="pauseVideo"
              v-if="placement_review == 'spotlight'"
              class="data-review spotlight-review"
            >
              <div class="header">
                <svg viewBox="0 0 394 49" xmlns="http://www.w3.org/2000/svg">
                  <rect transform="translate(0.5 0.753906)" fill="black"></rect>
                  <path
                    opacity="0.5"
                    d="M365.281 24.7539V28.7847C365.892 28.4433 366.289 27.6491 366.289 26.7693C366.289 25.8894 365.892 25.0953 365.281 24.7539Z"
                    fill="#ECECEE"
                  ></path>
                  <rect
                    opacity="0.5"
                    x="339.586"
                    y="21.2265"
                    width="24.1846"
                    height="11.0846"
                    rx="3.52692"
                    stroke="#ECECEE"
                    stroke-width="1.00769"
                  ></rect>
                  <rect
                    x="341.098"
                    y="22.7383"
                    width="21.1615"
                    height="8.06154"
                    rx="2.01538"
                    fill="#ECECEE"
                  ></rect>
                  <path
                    d="M323.464 23.234C325.95 23.2341 328.34 24.173 330.142 25.8567C330.277 25.9867 330.494 25.985 330.628 25.853L331.924 24.5665C331.992 24.4995 332.03 24.4088 332.029 24.3144C332.029 24.2201 331.99 24.1298 331.921 24.0636C327.193 19.609 319.734 19.609 315.006 24.0636C314.938 24.1298 314.899 24.22 314.898 24.3144C314.898 24.4087 314.935 24.4995 315.003 24.5665L316.3 25.853C316.434 25.9852 316.651 25.9869 316.786 25.8567C318.588 24.1729 320.979 23.234 323.464 23.234ZM323.464 27.4197C324.83 27.4196 326.147 27.9186 327.159 28.8198C327.296 28.9477 327.512 28.9449 327.645 28.8135L328.94 27.527C329.009 27.4595 329.046 27.368 329.045 27.2728C329.044 27.1777 329.005 27.0869 328.935 27.0208C325.853 24.2018 321.079 24.2018 317.996 27.0208C317.926 27.0869 317.887 27.1778 317.886 27.2729C317.885 27.3681 317.923 27.4596 317.991 27.527L319.286 28.8135C319.419 28.9449 319.635 28.9477 319.772 28.8198C320.784 27.9192 322.1 27.4202 323.464 27.4197ZM325.953 30.4901C326.023 30.4233 326.061 30.3313 326.059 30.2359C326.057 30.1405 326.015 30.0501 325.943 29.9861C324.512 28.7964 322.417 28.7964 320.986 29.9861C320.914 30.0501 320.872 30.1404 320.87 30.2358C320.868 30.3312 320.906 30.4232 320.975 30.4901L323.216 32.7129C323.281 32.7782 323.371 32.815 323.464 32.815C323.558 32.815 323.647 32.7782 323.713 32.7129L325.953 30.4901Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M288.877 28.2803H290.062C290.717 28.2803 291.248 28.7879 291.248 29.414V31.6813C291.248 32.3074 290.717 32.815 290.062 32.815H288.877C288.222 32.815 287.691 32.3074 287.691 31.6813V29.414C287.691 28.7879 288.222 28.2803 288.877 28.2803ZM294.409 26.013H295.595C296.25 26.013 296.78 26.5206 296.78 27.1467V31.6813C296.78 32.3074 296.25 32.815 295.595 32.815H294.409C293.755 32.815 293.224 32.3074 293.224 31.6813V27.1467C293.224 26.5206 293.755 26.013 294.409 26.013ZM299.942 23.3678H301.127C301.782 23.3678 302.313 23.8754 302.313 24.5015V31.6813C302.313 32.3074 301.782 32.815 301.127 32.815H299.942C299.287 32.815 298.756 32.3074 298.756 31.6813V24.5015C298.756 23.8754 299.287 23.3678 299.942 23.3678ZM305.474 20.7227H306.66C307.314 20.7227 307.845 21.2302 307.845 21.8563V31.6813C307.845 32.3074 307.314 32.815 306.66 32.815H305.474C304.819 32.815 304.289 32.3074 304.289 31.6813V21.8563C304.289 21.2302 304.819 20.7227 305.474 20.7227Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M47.44 32.7227V22.8273H47.2978L44.2949 24.9352V22.8608L47.4484 20.6525H49.5981V32.7227H47.44ZM55.9385 32.7227V22.8273H55.7963L52.7934 24.9352V22.8608L55.9469 20.6525H58.0966V32.7227H55.9385ZM63.0819 31.0581C62.2956 31.0581 61.7435 30.4893 61.7435 29.7365C61.7435 28.9753 62.2956 28.4149 63.0819 28.4149C63.8765 28.4149 64.4202 28.9753 64.4202 29.7365C64.4202 30.4893 63.8765 31.0581 63.0819 31.0581ZM63.0819 24.9519C62.2956 24.9519 61.7435 24.3915 61.7435 23.6387C61.7435 22.8775 62.2956 22.3171 63.0819 22.3171C63.8765 22.3171 64.4202 22.8775 64.4202 23.6387C64.4202 24.3915 63.8765 24.9519 63.0819 24.9519ZM71.5134 33.0238C68.6193 33.0238 66.9045 30.6817 66.9045 26.675C66.9045 22.6851 68.6444 20.3514 71.5134 20.3514C74.3741 20.3514 76.114 22.6851 76.114 26.6918C76.114 30.6817 74.3992 33.0238 71.5134 33.0238ZM71.5134 31.2338C73.0442 31.2338 73.9308 29.6696 73.9308 26.675C73.9308 23.6972 73.0274 22.1498 71.5134 22.1498C69.9994 22.1498 69.0877 23.7056 69.0877 26.675C69.0877 29.6696 69.9827 31.2338 71.5134 31.2338ZM84.0688 32.7227V30.4224H78.1717V28.624C79.7359 25.8971 81.4506 23.1452 83.0901 20.6525H86.1348V28.5989H87.7659V30.4224H86.1348V32.7227H84.0688ZM80.1708 28.532V28.6491H84.1022V22.4091H83.9851C82.7471 24.2827 81.3502 26.4994 80.1708 28.532Z"
                    fill="#ECECEE"
                  ></path>
                </svg>
              </div>
              <div
                class="body d-flex align-center justify-space-between flex-column position-relative"
              >
                <div class="w-100 px-5 position-absolute" style="z-index: 5">
                  <img
                    src="@/assets/snapchatImage/spotlight-header.svg"
                    width="100%"
                    alt=""
                  />
                </div>
                <v-carousel height="100%" show-arrows="hover" hide-delimiters>
                  <v-carousel-item
                    v-for="(storySnap, i) in storiesSnaps"
                    :key="i"
                  >
                    <img
                      v-if="storySnap.image_url && storySnap.image_url !== ''"
                      width="100%"
                      height="100%"
                      :src="storySnap.image_url"
                      alt=""
                    />
                    <video
                      v-if="storySnap.video_url && storySnap.video_url !== ''"
                      autoplay
                      muted
                      loop
                      width="100%"
                      height="100%"
                      id="myVideo"
                    >
                      <source :src="storySnap.video_url" type="video/mp4" />
                    </video>
                  </v-carousel-item>
                </v-carousel>
                <div class="story-bottom-data">
                  <div class="story-ad-profile-button w-100">
                    <div
                      class="profile-ad d-flex justify-space-between align-end"
                    >
                      <div class="profile d-flex ga-2 mb-3">
                        <img
                          width="20"
                          src="https://cf-st.sc-cdn.net/d/YmmIFdcbee3keYymYPlJq?bo=Eg0aABoAMgEESAJQCGAB&uc=8"
                          alt=""
                        />
                        <span class="text-subtitle-2">Mohamed</span>
                      </div>
                      <div class="ad">Ad</div>
                    </div>
                    <div class="button">
                      <span class="standard-button">{{
                        storiesSnaps[activeStorySnapIndex].call_to_action
                      }}</span>
                    </div>
                  </div>
                  <div class="story-actions">
                    <div class="profile-favoriting-favoriting">
                      <div class="svg">
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 48 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="styles-5mtvke"
                        >
                          <g clip-path="url(#clip)">
                            <g filter="url(#filter-heart)">
                              <path
                                d="M24 15.1088C32.4677 4.43472 44.9916 15.6853 37.9154 26.6395C35.7984 30.8893 29.0331 36.0287 25.347 38.6643C24.9434 38.9465 24.4766 39.0963 24 39.0963C23.5233 39.0963 23.0563 38.9465 22.6528 38.6643C18.8926 36.0287 12.2013 30.8893 10.0844 26.6395C2.99341 15.6853 15.5914 4.43472 24 15.1088Z"
                                fill="white"
                              ></path>
                              <path
                                d="M25.6336 39.074L25.6336 39.0741L25.6378 39.071C27.4865 37.7492 30.1156 35.7937 32.5516 33.6311C34.9651 31.4884 37.2414 29.0975 38.3504 26.8875C41.9976 21.2197 40.6125 15.4001 37.113 12.3848C35.3639 10.8776 33.0877 10.0769 30.6811 10.3706C28.4155 10.6471 26.0857 11.8866 24.0013 14.3211C21.9299 11.8866 19.6058 10.6471 17.3418 10.3706C14.9367 10.0769 12.6575 10.8776 10.904 12.3843C7.39559 15.3989 5.994 21.2187 9.6495 26.8877C10.7579 29.0965 13.0144 31.4869 15.4197 33.6305C17.847 35.7937 20.4769 37.7498 22.3658 39.0737L22.3662 39.074C22.8508 39.413 23.4173 39.5963 24 39.5963C24.5827 39.5963 25.149 39.4129 25.6336 39.074Z"
                                stroke="black"
                                stroke-opacity="0.05"
                                stroke-miterlimit="10"
                              ></path>
                            </g>
                          </g>
                          <defs>
                            <filter
                              id="filter-heart"
                              x="-2"
                              y="-1.18945"
                              width="52"
                              height="52"
                              filterUnits="userSpaceOnUse"
                              color-interpolation-filters="sRGB"
                            >
                              <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                              ></feFlood>
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              ></feColorMatrix>
                              <feOffset></feOffset>
                              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                              ></feColorMatrix>
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_3_13290"
                              ></feBlend>
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_3_13290"
                                result="shape"
                              ></feBlend>
                            </filter>
                            <clipPath id="clip">
                              <rect
                                width="48"
                                height="48"
                                fill="white"
                                transform="translate(0 0.810547)"
                              ></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="svg">
                        <svg
                          class="styles-3jo2gc"
                          width="48"
                          height="48"
                          viewBox="0 0 156 156"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g filter="url(#filter-go)">
                            <path
                              d="M82.3862 39.7208L118.027 69.4408L117.987 69.4008C120.504 71.5208 121.982 74.6408 121.982 77.9608C121.982 81.2808 120.544 84.4008 117.987 86.5208L82.3862 116.201C80.9878 117.361 79.3096 117.961 77.5915 117.961C76.5127 117.961 75.4339 117.721 74.395 117.241C71.758 116.001 70.0798 113.401 70.0798 110.441V94.0408C62.0487 94.3208 50.4215 96.2008 41.3116 108.361C40.3127 109.681 38.6346 110.241 37.0363 109.801C35.4381 109.361 34.2794 108.001 34.1196 106.361C34.0396 105.561 32.2816 86.6008 44.0686 73.6008C50.3416 66.6808 59.052 62.8008 70.0798 62.0808V45.4808C70.0798 42.5208 71.718 39.9208 74.395 38.6808C77.0721 37.4408 80.1087 37.8408 82.3862 39.7208Z"
                              fill="white"
                            ></path>
                          </g>
                          <defs>
                            <filter
                              id="filter-go"
                              x="6"
                              y="12"
                              width="144"
                              height="144"
                              filterUnits="userSpaceOnUse"
                              color-interpolation-filters="sRGB"
                            >
                              <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                              ></feFlood>
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              ></feColorMatrix>
                              <feOffset dy="6"></feOffset>
                              <feGaussianBlur
                                stdDeviation="12"
                              ></feGaussianBlur>
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                              ></feColorMatrix>
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_108_1540"
                              ></feBlend>
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_108_1540"
                                result="shape"
                              ></feBlend>
                            </filter>
                          </defs>
                        </svg>
                      </div>
                      <div class="svg">
                        <svg
                          class="styles-3jo2gc"
                          width="48"
                          height="48"
                          viewBox="0 0 156 156"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g filter="url(#filter-more)">
                            <path
                              d="M48 88.001C53.5228 88.001 58 83.5238 58 78.001C58 72.4781 53.5228 68.001 48 68.001C42.4771 68.001 38 72.4781 38 78.001C38 83.5238 42.4771 88.001 48 88.001Z"
                              fill="white"
                            ></path>
                            <path
                              d="M78 88.001C83.5228 88.001 88 83.5238 88 78.001C88 72.4781 83.5228 68.001 78 68.001C72.4771 68.001 68 72.4781 68 78.001C68 83.5238 72.4771 88.001 78 88.001Z"
                              fill="white"
                            ></path>
                            <path
                              d="M118 78.001C118 83.5238 113.523 88.001 108 88.001C102.477 88.001 98 83.5238 98 78.001C98 72.4781 102.477 68.001 108 68.001C113.523 68.001 118 72.4781 118 78.001Z"
                              fill="white"
                            ></path>
                          </g>
                          <defs>
                            <filter
                              id="filter-more"
                              x="6"
                              y="12"
                              width="144"
                              height="144"
                              filterUnits="userSpaceOnUse"
                              color-interpolation-filters="sRGB"
                            >
                              <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                              ></feFlood>
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              ></feColorMatrix>
                              <feOffset dy="6"></feOffset>
                              <feGaussianBlur
                                stdDeviation="12"
                              ></feGaussianBlur>
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                              ></feColorMatrix>
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_101_1614"
                              ></feBlend>
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_101_1614"
                                result="shape"
                              ></feBlend>
                            </filter>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="storiesSnaps.length > 1" class="custom-pagination">
                  <span
                    v-for="(storySnap, i) in storiesSnaps"
                    :key="i"
                    :style="`width : calc(100% / ${storiesSnaps.length})`"
                    :class="['pagination-bar', { active: i === activeIndex }]"
                  ></span>
                </div>
              </div>
              <div
                class="footer-data d-flex justify-center align-center flex-column"
              >
                <img
                  src="@/assets/snapchatImage/mobile-bottom-buttons.svg"
                  alt=""
                />
                <div class="mobile-button"></div>
              </div>
            </div>
            <!-- discover feed  -->
            <div
              @mouseenter="playVideo"
              @mouseleave="pauseVideo"
              v-if="placement_review == 'discover_feed'"
              class="data-review spotlight-review"
            >
              <div class="header">
                <svg viewBox="0 0 394 49" xmlns="http://www.w3.org/2000/svg">
                  <rect transform="translate(0.5 0.753906)" fill="black"></rect>
                  <path
                    opacity="0.5"
                    d="M365.281 24.7539V28.7847C365.892 28.4433 366.289 27.6491 366.289 26.7693C366.289 25.8894 365.892 25.0953 365.281 24.7539Z"
                    fill="#ECECEE"
                  ></path>
                  <rect
                    opacity="0.5"
                    x="339.586"
                    y="21.2265"
                    width="24.1846"
                    height="11.0846"
                    rx="3.52692"
                    stroke="#ECECEE"
                    stroke-width="1.00769"
                  ></rect>
                  <rect
                    x="341.098"
                    y="22.7383"
                    width="21.1615"
                    height="8.06154"
                    rx="2.01538"
                    fill="#ECECEE"
                  ></rect>
                  <path
                    d="M323.464 23.234C325.95 23.2341 328.34 24.173 330.142 25.8567C330.277 25.9867 330.494 25.985 330.628 25.853L331.924 24.5665C331.992 24.4995 332.03 24.4088 332.029 24.3144C332.029 24.2201 331.99 24.1298 331.921 24.0636C327.193 19.609 319.734 19.609 315.006 24.0636C314.938 24.1298 314.899 24.22 314.898 24.3144C314.898 24.4087 314.935 24.4995 315.003 24.5665L316.3 25.853C316.434 25.9852 316.651 25.9869 316.786 25.8567C318.588 24.1729 320.979 23.234 323.464 23.234ZM323.464 27.4197C324.83 27.4196 326.147 27.9186 327.159 28.8198C327.296 28.9477 327.512 28.9449 327.645 28.8135L328.94 27.527C329.009 27.4595 329.046 27.368 329.045 27.2728C329.044 27.1777 329.005 27.0869 328.935 27.0208C325.853 24.2018 321.079 24.2018 317.996 27.0208C317.926 27.0869 317.887 27.1778 317.886 27.2729C317.885 27.3681 317.923 27.4596 317.991 27.527L319.286 28.8135C319.419 28.9449 319.635 28.9477 319.772 28.8198C320.784 27.9192 322.1 27.4202 323.464 27.4197ZM325.953 30.4901C326.023 30.4233 326.061 30.3313 326.059 30.2359C326.057 30.1405 326.015 30.0501 325.943 29.9861C324.512 28.7964 322.417 28.7964 320.986 29.9861C320.914 30.0501 320.872 30.1404 320.87 30.2358C320.868 30.3312 320.906 30.4232 320.975 30.4901L323.216 32.7129C323.281 32.7782 323.371 32.815 323.464 32.815C323.558 32.815 323.647 32.7782 323.713 32.7129L325.953 30.4901Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M288.877 28.2803H290.062C290.717 28.2803 291.248 28.7879 291.248 29.414V31.6813C291.248 32.3074 290.717 32.815 290.062 32.815H288.877C288.222 32.815 287.691 32.3074 287.691 31.6813V29.414C287.691 28.7879 288.222 28.2803 288.877 28.2803ZM294.409 26.013H295.595C296.25 26.013 296.78 26.5206 296.78 27.1467V31.6813C296.78 32.3074 296.25 32.815 295.595 32.815H294.409C293.755 32.815 293.224 32.3074 293.224 31.6813V27.1467C293.224 26.5206 293.755 26.013 294.409 26.013ZM299.942 23.3678H301.127C301.782 23.3678 302.313 23.8754 302.313 24.5015V31.6813C302.313 32.3074 301.782 32.815 301.127 32.815H299.942C299.287 32.815 298.756 32.3074 298.756 31.6813V24.5015C298.756 23.8754 299.287 23.3678 299.942 23.3678ZM305.474 20.7227H306.66C307.314 20.7227 307.845 21.2302 307.845 21.8563V31.6813C307.845 32.3074 307.314 32.815 306.66 32.815H305.474C304.819 32.815 304.289 32.3074 304.289 31.6813V21.8563C304.289 21.2302 304.819 20.7227 305.474 20.7227Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M47.44 32.7227V22.8273H47.2978L44.2949 24.9352V22.8608L47.4484 20.6525H49.5981V32.7227H47.44ZM55.9385 32.7227V22.8273H55.7963L52.7934 24.9352V22.8608L55.9469 20.6525H58.0966V32.7227H55.9385ZM63.0819 31.0581C62.2956 31.0581 61.7435 30.4893 61.7435 29.7365C61.7435 28.9753 62.2956 28.4149 63.0819 28.4149C63.8765 28.4149 64.4202 28.9753 64.4202 29.7365C64.4202 30.4893 63.8765 31.0581 63.0819 31.0581ZM63.0819 24.9519C62.2956 24.9519 61.7435 24.3915 61.7435 23.6387C61.7435 22.8775 62.2956 22.3171 63.0819 22.3171C63.8765 22.3171 64.4202 22.8775 64.4202 23.6387C64.4202 24.3915 63.8765 24.9519 63.0819 24.9519ZM71.5134 33.0238C68.6193 33.0238 66.9045 30.6817 66.9045 26.675C66.9045 22.6851 68.6444 20.3514 71.5134 20.3514C74.3741 20.3514 76.114 22.6851 76.114 26.6918C76.114 30.6817 74.3992 33.0238 71.5134 33.0238ZM71.5134 31.2338C73.0442 31.2338 73.9308 29.6696 73.9308 26.675C73.9308 23.6972 73.0274 22.1498 71.5134 22.1498C69.9994 22.1498 69.0877 23.7056 69.0877 26.675C69.0877 29.6696 69.9827 31.2338 71.5134 31.2338ZM84.0688 32.7227V30.4224H78.1717V28.624C79.7359 25.8971 81.4506 23.1452 83.0901 20.6525H86.1348V28.5989H87.7659V30.4224H86.1348V32.7227H84.0688ZM80.1708 28.532V28.6491H84.1022V22.4091H83.9851C82.7471 24.2827 81.3502 26.4994 80.1708 28.532Z"
                    fill="#ECECEE"
                  ></path>
                </svg>
                <img
                  width="100%"
                  height="15px"
                  src="@/assets/snapchatImage/discover-feed.svg"
                  alt=""
                />
              </div>
              <div
                class="body d-flex align-center justify-space-between flex-column position-relative"
              >
                <div class="discover-feed-body">
                  <span class="text-subtitle title">Discover</span>
                  <v-row class="discover-feed-cols">
                    <v-col
                      v-for="i in 4"
                      :key="i"
                      class="discover-feed-col"
                      cols="6"
                    >
                      <div
                        v-if="i === 2"
                        class="col-content"
                        :style="
                          background_image
                            ? { backgroundImage: `url(${background_image})` }
                            : {}
                        "
                      >
                        <img
                          class="logo"
                          v-if="logo_image"
                          :src="logo_image"
                          alt=""
                        />
                      </div>

                      <div v-else class="col-content"></div>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div
                class="footer-data d-flex justify-center align-center flex-column"
              >
                <svg
                  viewBox="0 0 375 56"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect fill="black"></rect>
                  <rect fill="black"></rect>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M37.5 39C38.1944 39 46 33.1944 46 27.5C46 22.8056 42.1944 19 37.5 19C32.8056 19 29 22.8056 29 27.5C29 33.1944 36.8056 39 37.5 39Z"
                    stroke="white"
                    stroke-width="1.5"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M37.5 30.5C39.1569 30.5 40.5 29.1569 40.5 27.5C40.5 25.8431 39.1569 24.5 37.5 24.5C35.8431 24.5 34.5 25.8431 34.5 27.5C34.5 29.1569 35.8431 30.5 37.5 30.5Z"
                    stroke="white"
                    stroke-width="1.5"
                  ></path>
                  <rect transform="translate(75)" fill="black"></rect>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M120.488 36.4017C120.488 36.7321 120.215 37 119.878 37C119.749 37 119.623 36.9595 119.518 36.8844L114.772 33.4718H108.271C106.189 33.4718 104.5 31.8143 104.5 29.7697V21.7021C104.5 19.6575 106.189 18 108.271 18H116.729C118.811 18 120.5 19.6575 120.5 21.7021L120.488 36.4017Z"
                    stroke="white"
                    stroke-width="1.5"
                  ></path>
                  <rect transform="translate(150)" fill="black"></rect>
                  <path
                    d="M189.214 18.0062L189.217 17.2562L189.214 18.0062ZM191.378 18.9787L190.787 19.4409L190.787 19.4409L191.378 18.9787ZM185.786 18.0062L185.783 17.2562L185.786 18.0062ZM183.622 18.9787L183.032 18.5164V18.5164L183.622 18.9787ZM183.311 19.3878L183.912 19.8373V19.8373L183.311 19.3878ZM182.648 20.2039L182.116 19.6755L182.116 19.6755L182.648 20.2039ZM181.014 21.0769L181.098 21.8222L181.099 21.8222L181.014 21.0769ZM180.966 21.0826L180.869 20.3389L180.869 20.3389L180.966 21.0826ZM179.704 21.2871L179.557 20.5517L179.704 21.2871ZM177.425 22.174L176.896 21.6428L176.896 21.6428L177.425 22.174ZM177.425 35.735L177.955 35.2038H177.955L177.425 35.735ZM197.575 35.735L197.045 35.2038L197.575 35.735ZM197.575 22.174L198.104 21.6428L198.104 21.6428L197.575 22.174ZM195.296 21.2871L195.443 20.5517L195.296 21.2871ZM194.034 21.0826L194.131 20.3389L194.131 20.3389L194.034 21.0826ZM193.986 21.0769L193.901 21.8222H193.902L193.986 21.0769ZM192.352 20.2039L191.819 20.7324V20.7324L192.352 20.2039ZM191.689 19.3878L192.289 18.9383V18.9383L191.689 19.3878ZM189.21 18.7562C189.797 18.759 190.103 18.8586 190.284 18.9582C190.467 19.0585 190.596 19.1962 190.787 19.4409L191.968 18.5164C191.755 18.2444 191.471 17.899 191.007 17.6439C190.542 17.388 189.968 17.2598 189.217 17.2562L189.21 18.7562ZM187.5 18.75C187.923 18.75 188.346 18.752 189.21 18.7562L189.217 17.2562C188.355 17.2521 187.927 17.25 187.5 17.25V18.75ZM185.79 18.7562C186.654 18.752 187.077 18.75 187.5 18.75V17.25C187.073 17.25 186.645 17.2521 185.783 17.2562L185.79 18.7562ZM184.213 19.4409C184.404 19.1962 184.533 19.0585 184.716 18.9582C184.897 18.8586 185.203 18.759 185.79 18.7562L185.783 17.2562C185.032 17.2598 184.458 17.388 183.993 17.6439C183.529 17.899 183.245 18.2444 183.032 18.5164L184.213 19.4409ZM183.912 19.8373C184.015 19.6997 184.114 19.5676 184.213 19.4409L183.032 18.5164C182.921 18.6578 182.812 18.8029 182.711 18.9383L183.912 19.8373ZM183.181 20.7324C183.436 20.4753 183.692 20.1305 183.912 19.8373L182.711 18.9383C182.471 19.2594 182.282 19.5086 182.116 19.6755L183.181 20.7324ZM181.099 21.8222C181.246 21.8055 181.547 21.7717 181.927 21.6122C182.305 21.4538 182.731 21.1849 183.181 20.7324L182.116 19.6755C181.796 19.9984 181.531 20.1518 181.347 20.2289C181.166 20.305 181.034 20.3199 180.93 20.3316L181.099 21.8222ZM181.063 21.8263C181.069 21.8255 181.079 21.8244 181.098 21.8222L180.93 20.3316C180.914 20.3334 180.891 20.336 180.869 20.3389L181.063 21.8263ZM179.851 22.0225C180.198 21.9531 180.6 21.8868 181.063 21.8263L180.869 20.3389C180.377 20.4032 179.942 20.4747 179.557 20.5517L179.851 22.0225ZM177.955 22.7052C178.075 22.5848 178.527 22.2877 179.851 22.0225L179.557 20.5517C178.168 20.8298 177.344 21.1963 176.896 21.6428L177.955 22.7052ZM176.75 28.8831C176.75 27.7796 176.827 26.4241 177.035 25.2227C177.139 24.6219 177.273 24.0775 177.438 23.63C177.607 23.1722 177.788 22.8717 177.955 22.7052L176.896 21.6428C176.508 22.0296 176.233 22.5613 176.03 23.1116C175.824 23.6721 175.671 24.3115 175.557 24.9667C175.33 26.2774 175.25 27.7232 175.25 28.8831H176.75ZM177.955 35.2038C177.792 35.0412 177.61 34.7364 177.44 34.2626C177.275 33.8011 177.14 33.2381 177.036 32.6183C176.827 31.3793 176.75 29.9867 176.75 28.8831H175.25C175.25 30.0427 175.33 31.5229 175.557 32.8674C175.67 33.5395 175.823 34.1959 176.028 34.7692C176.23 35.3303 176.504 35.8757 176.896 36.2662L177.955 35.2038ZM187.5 36.75C183.896 36.75 181.591 36.4614 180.134 36.1135C178.665 35.7629 178.118 35.3664 177.955 35.2038L176.896 36.2662C177.336 36.7051 178.188 37.1911 179.786 37.5725C181.396 37.9569 183.827 38.25 187.5 38.25V36.75ZM197.045 35.2038C196.882 35.3664 196.335 35.7629 194.866 36.1135C193.409 36.4614 191.104 36.75 187.5 36.75V38.25C191.173 38.25 193.604 37.9569 195.214 37.5726C196.812 37.1911 197.664 36.7051 198.104 36.2662L197.045 35.2038ZM198.25 28.8831C198.25 29.9867 198.173 31.3793 197.964 32.6183C197.86 33.2381 197.725 33.8011 197.56 34.2626C197.39 34.7364 197.208 35.0412 197.045 35.2038L198.104 36.2662C198.496 35.8757 198.77 35.3303 198.972 34.7692C199.177 34.1959 199.33 33.5395 199.443 32.8674C199.67 31.5229 199.75 30.0427 199.75 28.8831H198.25ZM197.045 22.7052C197.212 22.8717 197.393 23.1722 197.562 23.63C197.727 24.0775 197.861 24.6219 197.965 25.2227C198.173 26.4241 198.25 27.7796 198.25 28.8831H199.75C199.75 27.7232 199.67 26.2774 199.443 24.9667C199.329 24.3115 199.176 23.6721 198.97 23.1116C198.767 22.5613 198.492 22.0296 198.104 21.6428L197.045 22.7052ZM195.149 22.0225C196.473 22.2877 196.925 22.5848 197.045 22.7052L198.104 21.6428C197.656 21.1963 196.832 20.8298 195.443 20.5517L195.149 22.0225ZM193.937 21.8263C194.31 21.875 194.803 21.9533 195.149 22.0225L195.443 20.5517C195.057 20.4744 194.529 20.3909 194.131 20.3389L193.937 21.8263ZM193.902 21.8222C193.921 21.8244 193.931 21.8255 193.937 21.8263L194.131 20.3389C194.109 20.336 194.086 20.3334 194.07 20.3316L193.902 21.8222ZM191.819 20.7324C192.269 21.1849 192.695 21.4538 193.073 21.6122C193.453 21.7717 193.754 21.8055 193.901 21.8222L194.07 20.3316C193.966 20.3199 193.834 20.305 193.653 20.2289C193.469 20.1518 193.204 19.9984 192.884 19.6755L191.819 20.7324ZM191.088 19.8373C191.308 20.1305 191.564 20.4753 191.819 20.7324L192.884 19.6755C192.718 19.5086 192.529 19.2594 192.289 18.9383L191.088 19.8373ZM190.787 19.4409C190.886 19.5676 190.985 19.6997 191.088 19.8373L192.289 18.9383C192.188 18.8029 192.079 18.6578 191.968 18.5164L190.787 19.4409ZM187.501 33.578C190.319 33.578 192.614 31.3099 192.614 28.4997H191.114C191.114 30.4704 189.502 32.078 187.501 32.078V33.578ZM182.389 28.4997C182.389 31.3099 184.684 33.578 187.501 33.578V32.078C185.501 32.078 183.889 30.4704 183.889 28.4997H182.389ZM187.501 23.4214C184.684 23.4214 182.389 25.6895 182.389 28.4997H183.889C183.889 26.529 185.501 24.9214 187.501 24.9214V23.4214ZM192.614 28.4997C192.614 25.6895 190.319 23.4214 187.501 23.4214V24.9214C189.502 24.9214 191.114 26.529 191.114 28.4997H192.614Z"
                    fill="white"
                  ></path>
                  <rect transform="translate(225)" fill="black"></rect>
                  <path
                    d="M275.5 35.5001C275.445 35.1383 275.362 34.7856 275.254 34.4442C275.018 33.6966 274.659 33.0031 274.202 32.3868C272.921 30.6591 270.865 29.5391 268.547 29.5391C266.228 29.5391 264.172 30.6591 262.891 32.3868C262.434 33.0031 262.075 33.6966 261.839 34.4442C261.731 34.7856 261.648 35.1383 261.593 35.5001"
                    stroke="#A05DCD"
                    stroke-width="2"
                    stroke-linecap="round"
                  ></path>
                  <path
                    d="M259.534 30.7368C258.616 29.4013 257.142 28.5356 255.482 28.5356C253.821 28.5356 252.347 29.4013 251.429 30.7368C251.102 31.213 250.845 31.7491 250.676 32.3269C250.598 32.5908 250.539 32.8634 250.5 33.143"
                    stroke="#A05DCD"
                    stroke-width="2"
                    stroke-linecap="round"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M255.482 25.5247C257.147 25.5247 258.497 24.1768 258.497 22.5141C258.497 20.8513 257.147 19.5034 255.482 19.5034C253.817 19.5034 252.467 20.8513 252.467 22.5141C252.467 24.1768 253.817 25.5247 255.482 25.5247Z"
                    stroke="#A05DCD"
                    stroke-width="2"
                    stroke-linecap="round"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M268.546 26.5284C270.766 26.5284 272.566 24.7311 272.566 22.5142C272.566 20.2972 270.766 18.5 268.546 18.5C266.326 18.5 264.526 20.2972 264.526 22.5142C264.526 24.7311 266.326 26.5284 268.546 26.5284Z"
                    stroke="#A05DCD"
                    stroke-width="2"
                    stroke-linecap="round"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M266.782 55.0914C267.067 54.77 267.067 54.2488 266.782 53.9273L263.514 50.2411C263.372 50.0804 263.185 50 262.998 50C262.811 50 262.624 50.0804 262.482 50.2411L259.214 53.9273C258.929 54.2488 258.929 54.77 259.214 55.0914C259.499 55.4129 266.497 55.4129 266.782 55.0914Z"
                    fill="#A05DCD"
                  ></path>
                  <rect transform="translate(300)" fill="black"></rect>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M330 19.3847C330 18.3432 331.143 17.7059 332.029 18.2531L345.168 26.3684C346.009 26.8882 346.009 28.1118 345.168 28.6316L332.029 36.7469C331.143 37.2941 330 36.6568 330 35.6153V19.3847Z"
                    stroke="white"
                    stroke-width="1.5"
                  ></path>
                </svg>
                <div class="mobile-button"></div>
              </div>
            </div>
            <!-- between content  -->
            <div
              @mouseenter="playVideo"
              @mouseleave="pauseVideo"
              v-if="placement_review == 'between_content'"
              class="data-review spotlight-review"
            >
              <div class="header">
                <svg viewBox="0 0 394 49" xmlns="http://www.w3.org/2000/svg">
                  <rect transform="translate(0.5 0.753906)" fill="black"></rect>
                  <path
                    opacity="0.5"
                    d="M365.281 24.7539V28.7847C365.892 28.4433 366.289 27.6491 366.289 26.7693C366.289 25.8894 365.892 25.0953 365.281 24.7539Z"
                    fill="#ECECEE"
                  ></path>
                  <rect
                    opacity="0.5"
                    x="339.586"
                    y="21.2265"
                    width="24.1846"
                    height="11.0846"
                    rx="3.52692"
                    stroke="#ECECEE"
                    stroke-width="1.00769"
                  ></rect>
                  <rect
                    x="341.098"
                    y="22.7383"
                    width="21.1615"
                    height="8.06154"
                    rx="2.01538"
                    fill="#ECECEE"
                  ></rect>
                  <path
                    d="M323.464 23.234C325.95 23.2341 328.34 24.173 330.142 25.8567C330.277 25.9867 330.494 25.985 330.628 25.853L331.924 24.5665C331.992 24.4995 332.03 24.4088 332.029 24.3144C332.029 24.2201 331.99 24.1298 331.921 24.0636C327.193 19.609 319.734 19.609 315.006 24.0636C314.938 24.1298 314.899 24.22 314.898 24.3144C314.898 24.4087 314.935 24.4995 315.003 24.5665L316.3 25.853C316.434 25.9852 316.651 25.9869 316.786 25.8567C318.588 24.1729 320.979 23.234 323.464 23.234ZM323.464 27.4197C324.83 27.4196 326.147 27.9186 327.159 28.8198C327.296 28.9477 327.512 28.9449 327.645 28.8135L328.94 27.527C329.009 27.4595 329.046 27.368 329.045 27.2728C329.044 27.1777 329.005 27.0869 328.935 27.0208C325.853 24.2018 321.079 24.2018 317.996 27.0208C317.926 27.0869 317.887 27.1778 317.886 27.2729C317.885 27.3681 317.923 27.4596 317.991 27.527L319.286 28.8135C319.419 28.9449 319.635 28.9477 319.772 28.8198C320.784 27.9192 322.1 27.4202 323.464 27.4197ZM325.953 30.4901C326.023 30.4233 326.061 30.3313 326.059 30.2359C326.057 30.1405 326.015 30.0501 325.943 29.9861C324.512 28.7964 322.417 28.7964 320.986 29.9861C320.914 30.0501 320.872 30.1404 320.87 30.2358C320.868 30.3312 320.906 30.4232 320.975 30.4901L323.216 32.7129C323.281 32.7782 323.371 32.815 323.464 32.815C323.558 32.815 323.647 32.7782 323.713 32.7129L325.953 30.4901Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M288.877 28.2803H290.062C290.717 28.2803 291.248 28.7879 291.248 29.414V31.6813C291.248 32.3074 290.717 32.815 290.062 32.815H288.877C288.222 32.815 287.691 32.3074 287.691 31.6813V29.414C287.691 28.7879 288.222 28.2803 288.877 28.2803ZM294.409 26.013H295.595C296.25 26.013 296.78 26.5206 296.78 27.1467V31.6813C296.78 32.3074 296.25 32.815 295.595 32.815H294.409C293.755 32.815 293.224 32.3074 293.224 31.6813V27.1467C293.224 26.5206 293.755 26.013 294.409 26.013ZM299.942 23.3678H301.127C301.782 23.3678 302.313 23.8754 302.313 24.5015V31.6813C302.313 32.3074 301.782 32.815 301.127 32.815H299.942C299.287 32.815 298.756 32.3074 298.756 31.6813V24.5015C298.756 23.8754 299.287 23.3678 299.942 23.3678ZM305.474 20.7227H306.66C307.314 20.7227 307.845 21.2302 307.845 21.8563V31.6813C307.845 32.3074 307.314 32.815 306.66 32.815H305.474C304.819 32.815 304.289 32.3074 304.289 31.6813V21.8563C304.289 21.2302 304.819 20.7227 305.474 20.7227Z"
                    fill="#ECECEE"
                  ></path>
                  <path
                    d="M47.44 32.7227V22.8273H47.2978L44.2949 24.9352V22.8608L47.4484 20.6525H49.5981V32.7227H47.44ZM55.9385 32.7227V22.8273H55.7963L52.7934 24.9352V22.8608L55.9469 20.6525H58.0966V32.7227H55.9385ZM63.0819 31.0581C62.2956 31.0581 61.7435 30.4893 61.7435 29.7365C61.7435 28.9753 62.2956 28.4149 63.0819 28.4149C63.8765 28.4149 64.4202 28.9753 64.4202 29.7365C64.4202 30.4893 63.8765 31.0581 63.0819 31.0581ZM63.0819 24.9519C62.2956 24.9519 61.7435 24.3915 61.7435 23.6387C61.7435 22.8775 62.2956 22.3171 63.0819 22.3171C63.8765 22.3171 64.4202 22.8775 64.4202 23.6387C64.4202 24.3915 63.8765 24.9519 63.0819 24.9519ZM71.5134 33.0238C68.6193 33.0238 66.9045 30.6817 66.9045 26.675C66.9045 22.6851 68.6444 20.3514 71.5134 20.3514C74.3741 20.3514 76.114 22.6851 76.114 26.6918C76.114 30.6817 74.3992 33.0238 71.5134 33.0238ZM71.5134 31.2338C73.0442 31.2338 73.9308 29.6696 73.9308 26.675C73.9308 23.6972 73.0274 22.1498 71.5134 22.1498C69.9994 22.1498 69.0877 23.7056 69.0877 26.675C69.0877 29.6696 69.9827 31.2338 71.5134 31.2338ZM84.0688 32.7227V30.4224H78.1717V28.624C79.7359 25.8971 81.4506 23.1452 83.0901 20.6525H86.1348V28.5989H87.7659V30.4224H86.1348V32.7227H84.0688ZM80.1708 28.532V28.6491H84.1022V22.4091H83.9851C82.7471 24.2827 81.3502 26.4994 80.1708 28.532Z"
                    fill="#ECECEE"
                  ></path>
                </svg>
              </div>
              <div
                class="body d-flex align-center justify-space-between flex-column position-relative"
              >
                <div
                  v-if="storiesSnaps.length > 1"
                  class="custom-pagination"
                  style="top: -14px"
                >
                  <span
                    v-for="(storySnap, i) in storiesSnaps"
                    :key="i"
                    :style="`width : calc(100% / ${storiesSnaps.length})`"
                    :class="['pagination-bar', { active: i === activeIndex }]"
                  ></span>
                </div>
                <v-carousel height="100%" show-arrows="hover" hide-delimiters>
                  <v-carousel-item
                    v-for="(storySnap, i) in storiesSnaps"
                    :key="i"
                  >
                    <img
                      v-if="storySnap.image_url && storySnap.image_url !== ''"
                      width="100%"
                      height="100%"
                      :src="storySnap.image_url"
                      alt=""
                    />
                    <video
                      v-if="storySnap.video_url && storySnap.video_url !== ''"
                      autoplay
                      muted
                      loop
                      width="100%"
                      height="100%"
                      id="myVideo"
                    >
                      <source :src="storySnap.video_url" type="video/mp4" />
                    </video>
                  </v-carousel-item>
                  <div class="story-bottom-data">
                    <div class="story-ad-profile-button w-100">
                      <div
                        class="profile-ad between-content-profile-ad d-flex justify-space-between align-center"
                      >
                        <div class="profile d-flex ga-2 mb-3">
                          <img
                            width="50"
                            src="https://cf-st.sc-cdn.net/d/YmmIFdcbee3keYymYPlJq?bo=Eg0aABoAMgEESAJQCGAB&uc=8"
                            alt=""
                          />
                          <span
                            class="text-subtitle-2 d-flex justify-center align-center"
                            >Mohamed</span
                          >
                        </div>
                        <div>
                          <svg
                            class="styles-1dxk6ak"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M13.4857 12L7.83276 17.6529L9.24698 19.0671L16.3141 12L9.24698 4.93289L7.83276 6.34711L13.4857 12Z"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="story-actions">
                      <div class="profile-favoriting-favoriting">
                        <div class="svg">
                          <svg
                            width="48"
                            height="48"
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="styles-5mtvke"
                          >
                            <g clip-path="url(#clip)">
                              <g filter="url(#filter-heart)">
                                <path
                                  d="M24 15.1088C32.4677 4.43472 44.9916 15.6853 37.9154 26.6395C35.7984 30.8893 29.0331 36.0287 25.347 38.6643C24.9434 38.9465 24.4766 39.0963 24 39.0963C23.5233 39.0963 23.0563 38.9465 22.6528 38.6643C18.8926 36.0287 12.2013 30.8893 10.0844 26.6395C2.99341 15.6853 15.5914 4.43472 24 15.1088Z"
                                  fill="white"
                                ></path>
                                <path
                                  d="M25.6336 39.074L25.6336 39.0741L25.6378 39.071C27.4865 37.7492 30.1156 35.7937 32.5516 33.6311C34.9651 31.4884 37.2414 29.0975 38.3504 26.8875C41.9976 21.2197 40.6125 15.4001 37.113 12.3848C35.3639 10.8776 33.0877 10.0769 30.6811 10.3706C28.4155 10.6471 26.0857 11.8866 24.0013 14.3211C21.9299 11.8866 19.6058 10.6471 17.3418 10.3706C14.9367 10.0769 12.6575 10.8776 10.904 12.3843C7.39559 15.3989 5.994 21.2187 9.6495 26.8877C10.7579 29.0965 13.0144 31.4869 15.4197 33.6305C17.847 35.7937 20.4769 37.7498 22.3658 39.0737L22.3662 39.074C22.8508 39.413 23.4173 39.5963 24 39.5963C24.5827 39.5963 25.149 39.4129 25.6336 39.074Z"
                                  stroke="black"
                                  stroke-opacity="0.05"
                                  stroke-miterlimit="10"
                                ></path>
                              </g>
                            </g>
                            <defs>
                              <filter
                                id="filter-heart"
                                x="-2"
                                y="-1.18945"
                                width="52"
                                height="52"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                ></feFlood>
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                ></feColorMatrix>
                                <feOffset></feOffset>
                                <feGaussianBlur
                                  stdDeviation="4"
                                ></feGaussianBlur>
                                <feColorMatrix
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                ></feColorMatrix>
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_3_13290"
                                ></feBlend>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_3_13290"
                                  result="shape"
                                ></feBlend>
                              </filter>
                              <clipPath id="clip">
                                <rect
                                  width="48"
                                  height="48"
                                  fill="white"
                                  transform="translate(0 0.810547)"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-carousel>
                <div class="story-bottom-data" style="position: static">
                  <div class="story-ad-profile-button w-100">
                    <div class="button">
                      <span
                        style="
                          background-color: rgb(254, 251, 0);
                          margin-top: 5px;
                        "
                        class="standard-button"
                        >{{
                          storiesSnaps[activeStorySnapIndex].call_to_action
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="story-actions">
                    <div class="profile-favoriting-favoriting">
                      <div class="svg styles-lhpznm">
                        <svg
                          class="styles-3y3f29"
                          width="156"
                          height="156"
                          viewBox="0 0 156 156"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g filter="url(#filter-go)">
                            <path
                              d="M82.3862 39.7208L118.027 69.4408L117.987 69.4008C120.504 71.5208 121.982 74.6408 121.982 77.9608C121.982 81.2808 120.544 84.4008 117.987 86.5208L82.3862 116.201C80.9878 117.361 79.3096 117.961 77.5915 117.961C76.5127 117.961 75.4339 117.721 74.395 117.241C71.758 116.001 70.0798 113.401 70.0798 110.441V94.0408C62.0487 94.3208 50.4215 96.2008 41.3116 108.361C40.3127 109.681 38.6346 110.241 37.0363 109.801C35.4381 109.361 34.2794 108.001 34.1196 106.361C34.0396 105.561 32.2816 86.6008 44.0686 73.6008C50.3416 66.6808 59.052 62.8008 70.0798 62.0808V45.4808C70.0798 42.5208 71.718 39.9208 74.395 38.6808C77.0721 37.4408 80.1087 37.8408 82.3862 39.7208Z"
                              fill="white"
                            ></path>
                          </g>
                          <defs>
                            <filter
                              id="filter-go"
                              x="6"
                              y="12"
                              width="144"
                              height="144"
                              filterUnits="userSpaceOnUse"
                              color-interpolation-filters="sRGB"
                            >
                              <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                              ></feFlood>
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              ></feColorMatrix>
                              <feOffset dy="6"></feOffset>
                              <feGaussianBlur
                                stdDeviation="12"
                              ></feGaussianBlur>
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                              ></feColorMatrix>
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_108_1540"
                              ></feBlend>
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_108_1540"
                                result="shape"
                              ></feBlend>
                            </filter>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="footer-data d-flex justify-center align-center flex-column"
              >
                <div class="mobile-button" style="margin-top: 5px"></div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <v-container style="padding: 15px 0px">
    <div class="budget-and-schedule ad-set-details-card mb-6">
      <h6 class="page-header-title text-h6 mb-3">Discover Tile</h6>
      <v-card
        max-width="100%"
        class="pa-5 mb-5 rounded-lg budget-and-schedule-card"
        elevation="1"
      >
        <div class="">
          <div class="filed mt-3">
            <div class="title">Discover Tile</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleDiscoverTile"
                v-model:checked="discover_tile"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">Discover Tile Headline</span>
            <div class="input-container">
              <input
                type="text"
                v-model="discover_tile_headline"
                placeholder="Discover Tile Headline"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">Background</span>
            <div class="input-container">
              <UploadMedia
                :aspectRatio="3 / 5"
                :minAspectRatio="3 / 5"
                :maxAspectRatio="3 / 5"
                :minCropWidth="360"
                :minCropHeight="600"
                :cropWidth="360"
                :cropHeight="600"
                :size="2"
                @uploaded:id="(id) => updateBackgroundFile(id)"
                @uploaded:url="(url) => updateBackgroundImage(url)"
                @uploaded:delete="
                  () => {
                    background_image_file = '';
                    background_image = '';
                  }
                "
                :old_id="background_image_file"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <span class="title">Logo</span>
            <div class="input-container">
              <UploadMedia
                :aspectRatio="993 / 284"
                :minAspectRatio="993 / 284"
                :maxAspectRatio="993 / 284"
                :cropWidth="993"
                :cropHeight="284"
                :minCropWidth="993"
                :minCropHeight="284"
                :size="2"
                @uploaded:id="(id) => updateLogoFile(id)"
                @uploaded:url="(url) => updateLogoImage(url)"
                @uploaded:delete="
                  () => {
                    logo_image = '';
                    logo_image_file = '';
                  }
                "
                :old_id="logo_image_file"
              />
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </v-container>
  <v-container style="padding: 15px 0px">
    <div class="budget-and-schedule ad-set-details-card mb-6">
      <h6 class="page-header-title text-h6 mb-3">Delivery</h6>
      <v-card
        max-width="100%"
        class="pa-5 mb-5 rounded-lg budget-and-schedule-card"
        elevation="1"
      >
        <div class="">
          <div class="filed mt-3">
            <div class="title">Status</div>
            <div class="mt-2">
              <SwitchToogle
                @click="ToggleStatus"
                v-model:checked="delivery_status"
                :notAttached="false"
                :paused="false"
                :disabled="false"
              />
            </div>
          </div>
          <div class="filed mt-3">
            <div class="filed mt-3">
              <span class="title">Impression Trackers</span>
              <div class="input-container">
                <div
                  v-for="(impression_tracker, index) in impression_trackers"
                  :key="index"
                  class="impression-trackers-template d-flex align-center ga-3"
                >
                  <input
                    type="text"
                    v-model="impression_trackers[index].value"
                    placeholder="Impression Tracker"
                  />
                  <span
                    class="delete-btn"
                    v-if="impression_trackers.length > 1"
                    @click="removeImpressionTracker(index)"
                    >x</span
                  >
                </div>
                <div>
                  <span class="add-another" @click="addAnotherImpressionTracker"
                    >Add Another</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="filed mt-3">
            <div class="filed mt-3">
              <span class="title">Click Trackers</span>
              <div class="input-container">
                <div
                  v-for="(click_tracker, index) in click_trackers"
                  :key="index"
                  class="click-trackers-template d-flex align-center ga-3"
                >
                  <input
                    type="text"
                    v-model="click_trackers[index].value"
                    placeholder="Click Tracker"
                  />
                  <span
                    v-if="click_trackers.length > 1"
                    class="delete-btn"
                    @click="removeClickTracker(index)"
                    >x</span
                  >
                </div>
                <div>
                  <span class="add-another" @click="addAnotherClickTracker"
                    >Add Another</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </v-container>
</template>
<script>
import SwitchToogle from "../Label&input/SwitchToogle.vue";
import UploadAndCropImage from "./UploadAndCropImage.vue";
import UploadMedia from "./uploadMedia.vue";

export default {
  components: { SwitchToogle, UploadAndCropImage, UploadMedia },
  data: () => ({
    ad_name: "",
    brand_name: "",
    offer_details_ad_disclaimer: "",
    offer_details_ad_disclaimer_ratio: false,
    shareable: true,
    headline: "",
    call_to_action_items: [
      {
        title: "Apply Now",
        value: "apply_noe",
      },
      {
        title: "Book Now",
        value: "book_now",
      },
      {
        title: "Buy Now",
        value: "buy_now",
      },
      {
        title: "More",
        value: "more",
      },
    ],
    adTypes: [
      {
        name: "None",
        value: "NONE",
      },
      {
        name: "Website",
        value: "WEB_VIEW",
      },
      {
        name: "App Install",
        value: "APP_INSTALL",
      },
      {
        name: "Deep Link",
        value: "DEEP_LINK",
      },
    ],
    delivery_status: true,
    impression_trackers: [{ value: "" }],
    click_trackers: [{ value: "" }],
    placement_review: "between_content",
    storiesSnaps: [
      {
        active: true,
        image_url: "",
        video_url: "",
        media_id: "",
        call_to_action: "MORE",
        ad_favoriting: true,
        standard_button_color: true,
        website_url: "",
        selected_ad_type: "",
        app_name: "",
        deep_link_uri: "",
        ios_app_id: "",
        android_app_url: "",
        fallback_type: "app_install",
        custom_ios_product_page: "",
        custom_ios_product_page_id: "",
        fallback_website_url: "",
        image_app_icon_url: "",
        image_app_icon_id: "",
      },
    ],
    web_view_call_to_action_items: [
      {
        title: "Apply Now",
        value: "APPLY_NOW",
      },
      {
        title: "MORE",
        value: "MORE",
      },
      {
        title: "ORDER_NOW",
        value: "ORDER_NOW",
      },
      {
        title: "PLAY",
        value: "PLAY",
      },
      {
        title: "READ",
        value: "READ",
      },
      {
        title: "SHOP_NOW",
        value: "SHOP_NOW",
      },
      {
        title: "SHOW",
        value: "SHOW",
      },
      {
        title: "SIGN_UP",
        value: "SIGN_UP",
      },
      {
        title: "VIEW",
        value: "VIEW",
      },
      {
        title: "RESPOND",
        value: "RESPOND",
      },
      {
        title: "BUY_TICKETS",
        value: "BUY_TICKETS",
      },
      {
        title: "SHOWTIMES",
        value: "SHOWTIMES",
      },
      {
        title: "BOOK_NOW",
        value: "BOOK_NOW",
      },
      {
        title: "GET_NOW",
        value: "GET_NOW",
      },
      {
        title: "LISTEN",
        value: "LISTEN",
      },
      {
        title: "TRY",
        value: "TRY",
      },
      {
        title: "VOTE",
        value: "VOTE",
      },
      {
        title: "VIEW_MENU",
        value: "VIEW_MENU",
      },
      {
        title: "PRE_REGISTER",
        value: "PRE_REGISTER",
      },
      {
        title: "PLAY_GAME",
        value: "PLAY_GAME",
      },
    ],
    deep_link_ctas: [
      "DONATE",
      "PLAY",
      "SHOP_NOW",
      "SIGN_UP",
      "USE_APP",
      "MORE",
      "OPEN_APP",
      "TRY",
      "WATCH",
      "VIEW_PROFILE",
      "VOTE",
      "DIRECTIONS",
      "PRE_REGISTER",
      "PLAY_GAME",
      "DOWNLOAD",
    ],
    app_install_ctas: [
      {
        title: "DONATE",
        value: "DONATE",
      },
      {
        title: "DIRECTIONS",
        value: "DIRECTIONS",
      },
      {
        title: "ORDER_NOW",
        value: "ORDER_NOW",
      },
      {
        title: "PLAY",
        value: "PLAY",
      },
      {
        title: "DOWNLOAD",
        value: "DOWNLOAD",
      },
      {
        title: "SHOP_NOW",
        value: "SHOP_NOW",
      },
      {
        title: "INSTALL_NOW",
        value: "INSTALL_NOW",
      },
      {
        title: "SIGN_UP",
        value: "SIGN_UP",
      },
      {
        title: "USE_APP",
        value: "USE_APP",
      },
      {
        title: "WATCH",
        value: "WATCH",
      },

      {
        title: "BOOK_NOW",
        value: "BOOK_NOW",
      },
      {
        title: "GET_NOW",
        value: "GET_NOW",
      },

      {
        title: "TRY",
        value: "TRY",
      },
      {
        title: "VOTE",
        value: "VOTE",
      },

      {
        title: "PLAY_GAME",
        value: "PLAY_GAME",
      },
    ],
    discover_tile: true,
    activeStorySnapIndex: 0,
    discover_tile_headline: "",
    logo_image: "",
    logo_image_file: "",
    background_image: "",
    background_image_file: "",
    CarouselActiveIndex: 0,
    user_info: JSON.parse(localStorage.getItem("user_info")) || "",
    public_profile_id:
      JSON.parse(localStorage.getItem("public_profile_id")) || "",
  }),
  methods: {
    updateID(id, index) {
      this.storiesSnaps[index].media_id = id;
    },
    updateImageUrl(url, index) {
      this.storiesSnaps[index].image_url = url;
      this.storiesSnaps[index].video_url = "";
    },
    updateVideoUrl(url, index) {
      this.storiesSnaps[index].video_url = url;
      this.storiesSnaps[index].image_url = "";
    },
    deleteFile(index) {
      this.storiesSnaps[index].video_url = "";
      this.storiesSnaps[index].image_url = "";
      this.storiesSnaps[index].media_id = "";
    },
    uploadStoryimageAppIconFile(index, id) {
      this.storiesSnaps[index].image_app_icon_id = id;
    },
    updateStoryAppIconImage(index, url) {
      this.storiesSnaps[index].image_app_icon_url = url;
    },
    deleteAppIcon(index) {
      this.storiesSnaps[index].image_app_icon_url = "";
      this.storiesSnaps[index].image_app_icon_id = "";
    },
    ToggleShareable() {
      this.ToggleShareable = !this.ToggleShareable;
    },
    updateImage(croppedImage, index) {
      this.storiesSnaps[index].image_url = croppedImage;
    },
    updateVideo(croppedVideo, index) {
      this.storiesSnaps[index].video_url = croppedVideo;
    },
    updateLogoImage(croppedImage) {
      this.logo_image = croppedImage;
    },
    updateLogoFile(file) {
      this.logo_image_file = file;
    },
    updateBackgroundImage(url) {
      this.background_image = url;
    },
    updateBackgroundFile(id) {
      this.background_image_file = id;
    },
    TogglePostToPublicProfile() {
      this.TogglePostToPublicProfile = !this.TogglePostToPublicProfile;
    },
    ToggleAdFavoriting() {
      this.ToggleAdFavoriting = !this.ToggleAdFavoriting;
    },
    ToggleStandardButtonColor() {
      this.ToggleStandardButtonColor = !this.ToggleStandardButtonColor;
    },
    ToggleSmartPerefetching() {
      this.ToggleSmartPerefetching = !this.ToggleSmartPerefetching;
    },
    ToggleStatus() {
      this.ToggleStatus = !this.ToggleStatus;
    },
    ToggleDiscoverTile() {
      this.ToggleDiscoverTile = !this.ToggleDiscoverTile;
    },
    addAnotherImpressionTracker() {
      this.impression_trackers.push({ value: "" });
    },

    removeImpressionTracker(index) {
      if (this.impression_trackers.length > 1) {
        this.impression_trackers.splice(index, 1);
      }
    },
    addAnotherClickTracker() {
      this.click_trackers.push({ value: "" });
    },
    removeClickTracker(index) {
      if (this.click_trackers.length > 1) {
        this.click_trackers.splice(index, 1);
      }
    },
    playVideo(event) {
      const video = event.target.querySelector("video");
      if (video) video.play();
    },
    pauseVideo(event) {
      const video = event.target.querySelector("video");
      if (video) video.pause();
    },
    addNewStorySnap() {
      if (this.storiesSnaps.length < 10) {
        this.storiesSnaps.push({
          active: false,
          image_url: "",
          video_url: "",
          media_id: "",
          call_to_action: "MORE",
          ad_favoriting: true,
          standard_button_color: true,
          website_url: "",
          selected_ad_type: "",
          app_name: "",
          deep_link_uri: "",
          ios_app_id: "",
          android_app_url: "",
          fallback_type: "app_install",
          custom_ios_product_page: "",
          custom_ios_product_page_id: "",
          fallback_website_url: "",
          image_app_icon_url: "",
        });
      }
    },
    RemoveStorySnap(index) {
      if (this.storiesSnaps[index].active) {
        const nextIndex = index === 0 ? 1 : 0;
        this.OpenStorySnap(nextIndex);
      }
      this.storiesSnaps.splice(index, 1);
      if (index === 0) {
        this.OpenStorySnap(0);
      }
    },
    OpenStorySnap(index) {
      this.activeStorySnapIndex = index;
      this.storiesSnaps.forEach((snap) => {
        snap.active = false;
      });
      this.storiesSnaps[index].active = true;
    },
    getButtonStyle(index, type) {
      const isActive = this.storiesSnaps[index].fallback_type === type;
      return {
        backgroundColor: isActive ? "black" : "white",
        color: isActive ? "white" : "black",
      };
    },
  },
  watch: {
    impression_trackers: {
      handler(v) {
        localStorage.setItem("impression_trackers", JSON.stringify(v));
      },
      deep: true,
    },
    click_trackers: {
      handler(v) {
        localStorage.setItem("click_trackers", JSON.stringify(v));
      },
      deep: true,
      // localStorage.setItem("click_trackers", JSON.stringify(v));
    },
    discover_tile(v) {
      localStorage.setItem("discover_tile", v);
    },
    delivery_status(v) {
      localStorage.setItem("delivery_status", v);
    },
    discover_tile_headline(v) {
      localStorage.setItem("discover_tile_headline", v);
    },
    logo_image(v) {
      localStorage.setItem("logo_image", v);
    },
    logo_image_file(v) {
      localStorage.setItem("logo_image_file", v);
    },
    background_image(v) {
      localStorage.setItem("background_image", v);
    },
    background_image_file(v) {
      localStorage.setItem("background_image_file", v);
    },
    ad_name(v) {
      localStorage.setItem("ad_name", v);
    },
    brand_name(v) {
      localStorage.setItem("brand_name", v);
    },
    offer_details_ad_disclaimer(v) {
      localStorage.setItem("offer_details_ad_disclaimer", v);
    },
    offer_details_ad_disclaimer_ratio(v) {
      localStorage.setItem("offer_details_ad_disclaimer_ratio", v);
    },
    shareable(v) {
      localStorage.setItem("shareable", v);
    },
    headline(v) {
      localStorage.setItem("headline", v);
    },
    activeIndex(val) {
      this.$refs.carousel.goTo(val);
    },
    storiesSnaps: {
      handler(newValue) {
        localStorage.setItem("story_ad", JSON.stringify(newValue));
      },
      deep: true,
    },
  },
  mounted() {
    this.ad_name = localStorage.getItem("ad_name") || "";
    this.brand_name = localStorage.getItem("brand_name") || "";
    this.headline = localStorage.getItem("headline") || "";
    this.offer_details_ad_disclaimer =
      localStorage.getItem("offer_details_ad_disclaimer") || "";
    this.offer_details_ad_disclaimer_ratio =
      localStorage.getItem("offer_details_ad_disclaimer_ratio") || false;
    this.shareable = localStorage.getItem("shareable") || true;

    this.storiesSnaps = JSON.parse(localStorage.getItem("story_ad")) || [
      {
        active: false,
        image_url: "",
        video_url: "",
        media_id: "",
        call_to_action: "MORE",
        ad_favoriting: true,
        standard_button_color: true,
        website_url: "",
        selected_ad_type: "",
        app_name: "",
        deep_link_uri: "",
        ios_app_id: "",
        android_app_url: "",
        fallback_type: "app_install",
        custom_ios_product_page: "",
        custom_ios_product_page_id: "",
        fallback_website_url: "",
        image_app_icon_url: "",
      },
    ];
    this.OpenStorySnap(0);

    this.discover_tile = localStorage.getItem("discover_tile") || false;
    this.discover_tile_headline =
      localStorage.getItem("discover_tile_headline") || "";
    this.logo_image = localStorage.getItem("logo_image") || "";
    this.logo_image_file = localStorage.getItem("logo_image_file") || "";
    this.background_image = localStorage.getItem("background_image") || "";
    this.background_image_file =
      localStorage.getItem("background_image_file") || "";
    this.delivery_status = localStorage.getItem("delivery_status") || true;
    this.impression_trackers = JSON.parse(
      localStorage.getItem("impression_trackers")
    ) || [{ value: "" }];
    this.click_trackers = JSON.parse(
      localStorage.getItem("click_trackers")
    ) || [{ value: "" }];
  },
};
</script>
